import { RequestTimeoutError } from "@trafficplace/api-client";
import { getStartParam } from "./tg";
import { withInteractiveReadTimeout } from "./requestTimeout";

export type Mode = "driver" | "sponsor" | "enduser";
type RequestedMode = "driver" | "sponsor";
export type ResourceLaunch = { resourceId: number; flowToken: string };

export async function detectMode(): Promise<{
  mode: Mode;
  me: any | null;
  flowToken?: string;
  autoOpenResourceId?: number;
}> {
  const startParam = getStartParam();
  const resourceLaunch = parseResourceLaunch(startParam);
  if (resourceLaunch) {
    return {
      mode: "enduser",
      me: null,
      flowToken: resourceLaunch.flowToken,
      autoOpenResourceId: resourceLaunch.resourceId,
    };
  }
  if (startParam?.startsWith("flow_")) {
    return { mode: "enduser", me: null, flowToken: startParam.slice(5) };
  }
  const requestedMode = getRequestedMode();
  try {
    const r = await withInteractiveReadTimeout((signal) =>
      fetch("/api/me", {
        headers: { Authorization: `tma ${window.Telegram.WebApp.initData}` },
        signal,
      }),
    );
    if (!r.ok) {
      if (requestedMode) {
        throw new Error("доступ к этому разделу не подтверждён. откройте Mini App из нужного бота после одобрения заявки.");
      }
      throw new Error("не удалось определить раздел. откройте Mini App из кнопки нужного бота или используйте ссылку потока.");
    }
    const body = await r.json();
    if (body.kind === "registered") {
      return { mode: body.role as Mode, me: body };
    }
    if (body.kind === "role_mismatch") {
      throw new Error(
        body.requested_role === "sponsor"
          ? "этот telegram id одобрен как заливщик. спонсорский бот и кабинет для него закрыты."
          : "этот telegram id одобрен как спонсор. бот заливщика и кабинет для него закрыты.",
      );
    }
    if (requestedMode) {
      throw new Error("заявка для этого бота ещё не одобрена.");
    }
    throw new Error("заявка ещё не одобрена или ссылка открыта не из нужного бота.");
  } catch (e) {
    if (e instanceof RequestTimeoutError) {
      throw new Error(
        requestedMode
          ? "не удалось проверить доступ. откройте Mini App из нужного бота и попробуйте ещё раз."
          : "не удалось определить раздел. откройте Mini App из кнопки нужного бота или используйте ссылку потока.",
      );
    }
    if (e instanceof Error) throw e;
    if (requestedMode) {
      throw new Error("не удалось проверить доступ. откройте Mini App из нужного бота и попробуйте ещё раз.");
    }
    throw new Error("не удалось определить раздел. откройте Mini App из кнопки нужного бота или используйте ссылку потока.");
  }
}

export function getInitialResourceLaunch(): ResourceLaunch | null {
  return parseResourceLaunch(getStartParam());
}

export function isResourceAutoOpenLaunch(): boolean {
  return getInitialResourceLaunch() !== null;
}

function getRequestedMode(): RequestedMode | undefined {
  if (typeof window === "undefined") return undefined;
  const value = new URLSearchParams(window.location.search).get("mode");
  return value === "driver" || value === "sponsor" ? value : undefined;
}

function parseResourceLaunch(startParam: string | undefined): ResourceLaunch | null {
  if (!startParam?.startsWith("res_")) return null;
  const rest = startParam.slice(4);
  const separator = rest.indexOf("_");
  if (separator <= 0) return null;
  const resourceId = Number.parseInt(rest.slice(0, separator), 10);
  const flowToken = rest.slice(separator + 1);
  if (!Number.isSafeInteger(resourceId) || resourceId <= 0 || !flowToken) {
    return null;
  }
  return { resourceId, flowToken };
}
